import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { FormGroup, ValidationErrors } from "@angular/forms";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { LocalStorageService } from "./local-storage.service";

export class Country {
    id: number;
    name: string;
    code: string;
}

enum EndpointRoutes {
    GET_COUNTRIES = "country/all",
}

@Injectable({
    providedIn: "root",
})
export class SharedService {
    public sidenavToggle: EventEmitter<null> = new EventEmitter(null);

    constructor(
        private _http: HttpClient,
        private _localStorageService: LocalStorageService,
    ) {}

    public getCurrentLanguage() {
        const currentLang = this._localStorageService.getAppLocalStorageObject().lang;
        switch (currentLang) {
            case "de":
                return "de-DE";
            case "it":
                return "it-IT";
            default:
                return "en-EN";
        }
    }

    public getCountries(): Observable<Country[]> {
        return this._http.get<Country[]>(environment.serverUrl + EndpointRoutes.GET_COUNTRIES).pipe(
            map((responseData) => {
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    checkIfFormGroupHasError(formGroup: FormGroup): { key: string; error: { [errorKey: string]: boolean } }[] {
        const result = [];
        Object.keys(formGroup.controls).forEach((key) => {
            const controlErrors: ValidationErrors = formGroup.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach((keyError) => {
                    const errorObject = {};
                    console.log("Key control: " + key + ", keyError: " + keyError + ", err value: ", controlErrors[keyError]);
                    errorObject[keyError] = controlErrors[keyError];
                    result.push({ key, error: errorObject });
                });
            }
        });
        return result;
    }
}
